module.exports = __webpack_public_path__ + "img/6.16155d7f.jpg";